import { useQuery } from "@tanstack/react-query";
import { vehiclesService } from "../services";

export const VEHICLE_EXPEDIENT_QUERY_KEY = "vehicle-expedient";

export const useGetExpedient = (vehicleId: string) =>
	useQuery({
		queryKey: [VEHICLE_EXPEDIENT_QUERY_KEY, vehicleId],
		queryFn: () => vehiclesService.getExpedient(vehicleId),
		enabled: !!vehicleId,
		retry: false,
		staleTime: Number.POSITIVE_INFINITY,
		refetchOnMount: false,
		refetchOnWindowFocus: false,
	});
